// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDaranalysisIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDaranalysisIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDaranalysisIconOutlined = function DrrpDaranalysisIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDaranalysisIconOutlinedSvg
  }));
};

DrrpDaranalysisIconOutlined.displayName = 'DrrpDaranalysisIconOutlined';
export default React.forwardRef(DrrpDaranalysisIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDaranalysisIconOutlined.js
// module id = 2515
// module chunks = 0